import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import 'react-dates/initialize';
import { isInclusivelyAfterDay, SingleDatePicker } from 'react-dates';

export default function SingleDatePickerWrapper({ initialDate, onDateChange, isOutsideRange }) {
  const [focused, setFocused] = React.useState(false);
  const [date, setDate] = React.useState(initialDate);

  React.useEffect(() => {
    initialDate && setDate(initialDate);
  }, [initialDate]);

  const dateChangeHandler = d => {
    onDateChange(d);
    setDate(d);
  };

  return (
    <SingleDatePicker
      date={date}
      onDateChange={dateChangeHandler}
      focused={focused}
      onFocusChange={d => setFocused(d.focused)}
      isOutsideRange={isOutsideRange}
      displayFormat={moment.localeData('en-au').longDateFormat('L')}
    />
  );
}

SingleDatePickerWrapper.propTypes = {
  initialDate: PropTypes.instanceOf(moment),
  onDateChange: PropTypes.func.isRequired,
  isOutsideRange: PropTypes.func,
};

SingleDatePickerWrapper.defaultProps = {
  initialDate: null,
  isOutsideRange: (d => !isInclusivelyAfterDay(d, moment())),
};
